import script from "./SyncPhases.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncPhases.vue?vue&type=script&setup=true&lang=js"

import "./SyncPhases.vue?vue&type=style&index=0&id=bae1ba76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae1ba76"]])

export default __exports__